import { SubticketTypeFieldValue } from './subticket-type-field-value';

export class DxiItem extends SubticketTypeFieldValue {
  public EditorOptions: any;
  public EditorType: string;
  public UseCustomTemplate: boolean;
}
